var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showIframe)?_c('div',{class:['iframe-modal', { alpha: _vm.pageLoaded }]},[_c('div',{staticClass:"iframe-container",style:(_vm.containerSize)})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }